import { render, staticRenderFns } from "./Generalstaff.vue?vue&type=template&id=1ddc1690&scoped=true&"
import script from "./Generalstaff.vue?vue&type=script&lang=js&"
export * from "./Generalstaff.vue?vue&type=script&lang=js&"
import style0 from "./Generalstaff.vue?vue&type=style&index=0&id=1ddc1690&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddc1690",
  null
  
)

export default component.exports